import {
  CreateOrGetPreSessionDocument,
  CreateOrGetPreSessionMutation,
} from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

export type CreateOrGetPreSessionRes =
  CreateOrGetPreSessionMutation['createOrGetExpPreSession']['explanationPreSession']

export const createOrGetPreSession = async ({
  explanationRevisionUid,
  explanationReservationUid,
  isPatient,
}: {
  explanationRevisionUid: string
  explanationReservationUid?: string
  isPatient: boolean
}): Promise<CreateOrGetPreSessionRes> => {
  try {
    const res = await graphqlRequest(CreateOrGetPreSessionDocument, {
      input: {
        explanationRevisionUid,
        explanationReservationUid,
      },
      isPatient,
    })
    return res.createOrGetExpPreSession.explanationPreSession
  } catch (error) {
    throw error
  }
}
